// extracted by mini-css-extract-plugin
export var card = "related-links-module--card--4c15f";
export var cardWhite = "related-links-module--cardWhite--78180";
export var description = "related-links-module--description--7254a";
export var header = "related-links-module--header--14632";
export var list = "related-links-module--list--eb216";
export var listItem = "related-links-module--listItem--e08e6";
export var title = "related-links-module--title--897a0";